The `CandidateProcessHistoryItem` for the given `id`.
